class PortalConfig {
    /**
     * Vue.JS component class to be rendered inside the info dropdown menu.
     */
    headerInfoComponent = null;
    /**
     * Additional navigation items to be displayed in the header.
     */
    headerNavItems = [];
    /**
     * Projects can supply their own routes to be added to the default routes.
     */
    customRoutes = [];
    /**
     * How many weeks ahead delivery dates should be selectable.
     * Note: should be matched with `paloma-shop.delivery-options.maximum-days-ahead`.
     */
    cartDeliveryDaysMaxWeeksAhead = 2;
    /**
     * How many weeks should be displayed at once when selecting delivery dates.
     */
    cartDeliveryDaysVisibleWeeks = 3;
    /**
     * Whether to allow selecting the product unit to order if there are
     * multiple. If this is set to {@code deny}, the user will not get a choice.
     * By default, the "defaultOrderingUnit" is selected.
     */
    articleOrderingUnitSelection = 'deny';
    /**
     * Whether watchlist sharing features are enabled in the B2B portal UI.
     */
    watchlistsSharingEnabled = false;
    watchlistsSharingIcon = 'share';
    /**
     * How many items of a watchlist will be loaded at the same time.
     */
    watchlistsItemPageSize = 25;
    extensions = {
        /**
         * Custom component to be rendered below the watchlist access token in
         * the watchlist share modal.
         */
        watchlistAccessToken: null,
    };
    overrides = {
        /**
         * Add custom components to be rendered for the given route.
         */
        views: {
            deliveries_delivery: undefined,
        },
    };
    /**
     * Whether Access Requests feature is enabled in the B2B portal UI.
     */
    accessRequestsEnabled = true;
    /**
     * Array defining the unitCode of ProductUnit to display in the B2B portal UI.
     * e.g. ['PC']
     */
    displayProductUnits;
    /**
     * Defines whether the next lower unit of a particular unit should be displayed in the B2B portal UI.
     */
    displayContainedUnits = false;
    /**
     * Whether to display product unit MSRP
     */
    displayProductUnitMsrp = false;
    showPriceUnavailableAltText = false;
    /**
     * CartView: show comment text area.
     * historical default value.
     */
    showCartComment = true;
    /**
     * CartView: show customer order number text field.
     * new feature, default disabled.
     */
    showCartCustomerOrderNumber = false;
    /**
     * CartView: maximum length of customer order number text field.
     * Only relevant when showCartCustomerOrderNumber = true.
     */
    cartCustomerOrderNumberMaxLength;
    /**
     * Whether to show delivery locations
     */
    cartDeliveryLocations = 'show_options';
    /**
     * Configuration to display product variants with options as matrix.
     * If a product has variants with options matching a config entry (exactly),
     * the variants will be shown as a matrix.
     */
    productOptionsMatrices = [
        {
            optionX: 'size',
            optionY: 'color',
        },
        {
            optionX: 'size',
            optionY: 'color',
            optionZ: 'length',
        },
    ];
    productExport = {
        maxExportTimeMs: 900000, // 15min
        formats: [],
    };
    productImages = {
        sizes: {
            /**
             * Image source size to be used for default-sized images.
             */
            default: 'medium',
            /**
             * Image source size to be used for thumbnail images.
             */
            thumbnail: 'small',
        },
    };
    productDetails = {
        descriptionProperty: 'description',
        displayDeliveryDays: false,
        /**
         * If the product has multiple variants, the product view
         * will redirect to the detail view of the first variant.
         */
        redirectToFirstVariant: false,
    };
    /**
     * UI settings for specific product attributes (catalog view v2).
     */
    productAttributes = {
        icons: {
        // add attribute value code icons here
        },
    };
    /**
     * UI setting to show past orders for a product on the product page.
     */
    productShowPastOrders = false;
    catalog = {
        /**
         * Which catalog view to use by default ('v1' or 'v2').
         */
        defaultView: 'v1',
        defaultViewMode: 'grid',
        /**
         * Whether to allow the user to select the catalog view version.
         */
        allowCatalogViewSelection: false,
        search: {
            showCategorySuggestions: false,
            filters: {},
            /**
             * How many filters to show initially
             */
            initialFilterCount: 5,
        },
        pageSize: 25,
    };
    /**
     * Category tree settings (catalog view v2).
     */
    categories = {
        /**
         * Category depth for fetching the category tree.
         */
        depth: 3,
        /**
         * Up to which level of the category tree should the category tree be expanded initially?
         */
        expand: 0,
        /**
         * Should empty categories be shown in the CatalogCategoryViewV2?
         */
        includeEmpty: true,
    };
    demand = {
        /**
         * Articles page size
         */
        pageSize: 50,
        /**
         * Show article images?
         */
        showImages: true,
        /**
         * How often should the demand calendar cutoff elements be refreshed (ms)?
         */
        refreshRate: 5000,
        showDownloadDemandData: true,
    };
    homePendingOrdersComponents = 'calendar';
    deliveries = {
        customDataColumns: [],
    };
}
const config = new PortalConfig();
export default config;
